import {
    apiRequest,
    rekapSyncPresensi,
    rekapketidakhadiranexport,
    listRekapAbsensi,
    masterWorkUnit,
    masterWorkUnit2,
    workunitall
} from "../../../../../services/adapters/kepegawaian/mappingMasaKerjaService"

class IndexRepository {

    fetchSync = async (query) => {
        return await apiRequest("get", rekapSyncPresensi, {
            params: query
        }, true)
    }

    fetchPresensiKetidakhadiranExport = async (query) => {
        return await apiRequest("get", rekapketidakhadiranexport, {
            params: query
        }, true)
    }

    fetchListRekapAbsensi = async (query) => {
        return await apiRequest("get", listRekapAbsensi, {
            params: query
        }, true)
    }
    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }
    fetchWorkUnit2 = async (query) => {
        return await apiRequest("get", masterWorkUnit2, {
            params: query
        }, true)
    }
    fetchWorkUnitAll = async (query) => {
        return await apiRequest("get", workunitall, {
            params: query
        }, true)
    }
    
}

export default IndexRepository